import { Col, Form, Row, Select, Input, Radio, Button } from "antd";
import { FC } from "react";

type PatientAttendantProps = {
  form: any;
  otpVerificationForm: any;
  handleOTPVerification: any;
  handleMobileVerification: any;
  isMobileNumberVerified?: boolean;
  isOTPVerified?: boolean;
  isOTPVerificationLoading?: boolean;
  patientResponse?: any;
};

const PatientAttendantDetails: FC<PatientAttendantProps> = ({
  form,
  handleOTPVerification,
  handleMobileVerification,
  otpVerificationForm,
  isMobileNumberVerified,
  isOTPVerified,
  isOTPVerificationLoading,
  patientResponse
}) => {
  const attendantType = Form.useWatch("attendantType", form);
  const relationship = Form.useWatch("relationship", form);

  const relationshipOptions = [
    { label: "Father", value: "father" },
    { label: "Mother", value: "mother" },
    { label: "Son", value: "son" },
    { label: "Daughter", value: "daughter" },
    { label: "Wife", value: "wife" },
    { label: "Husband", value: "husband" },
    { label: "Mother-in-law", value: "mother-in-law" },
    { label: "Father-in-law", value: "father-in-law" },
    { label: "Other", value: "other" },
  ];

  const onVerifyOTPClick = () => {
    handleOTPVerification();
  };

  const onVerifyMobileClick = async () => {
    try {
      await otpVerificationForm.validateFields();
      handleMobileVerification();
    } catch (err) {}
  };

  return (
    <>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "18px",
          marginBottom: "10px",
          fontWeight: "bold",
        }}
      >
        Patient Attendant Details
      </div>

      <Form
        form={form}
        layout="vertical"
        labelAlign="left"
        style={{ width: "100%", marginBottom: 0 }}
        initialValues={{ attendantType: "self" }}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item name="attendantType">
              <Radio.Group>
                <Radio value="self">Self</Radio>
                <Radio value="other">Other</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>

        {attendantType === "other" && (
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                label="Full Name"
                name="fullName"
                rules={[
                  { required: true, message: "Please enter full name" },
                  {
                    pattern: /^[A-Za-z\s./]+$/,
                    message: "Name can only contain letters",
                  },
                ]}
              >
                <Input placeholder="Type here" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Form.Item
                label="Relationship"
                name="relationship"
                rules={[
                  { required: true, message: "Please select relationship" },
                ]}
              >
                <Select
                  placeholder="Select Relationship"
                  allowClear
                  showSearch
                  options={relationshipOptions}
                />
              </Form.Item>
            </Col>

            {relationship === "other" && (
              <Col xs={24} sm={12} md={8}>
                <Form.Item
                  label="Other Relationship"
                  name="otherRelationship"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the relationship",
                    },
                  ]}
                >
                  <Input placeholder="Type here" />
                </Form.Item>
              </Col>
            )}
          </Row>
        )}
      </Form>

      <Form
        form={otpVerificationForm}
        layout="vertical"
        labelAlign="left"
        style={{ width: "100%" }}
        initialValues={{ mobile: patientResponse?.primaryMobile }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8}>
            <Form.Item
              label="Mobile Number"
              name="mobile"
              rules={[
                { required: true, message: "Please enter mobile number!" },
                {
                  pattern: /^\d{10}$/,
                  message: "MOBILE NUMBER MUST BE 10 DIGITS!",
                },
              ]}
            >
              <Input
                addonBefore="+91"
                placeholder="Type here.."
                maxLength={10}
                disabled={isOTPVerified}
                suffix={
                  isMobileNumberVerified ? (
                    <span style={{ color: "green", fontWeight: 500 }}>
                      VERIFIED
                    </span>
                  ) : (
                    <span
                      style={{
                        color: "#1677ff",
                        cursor: "pointer",
                        fontWeight: 500,
                      }}
                      onClick={() => onVerifyMobileClick()}
                    >
                      VERIFY
                    </span>
                  )
                }
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Form.Item label="Enter OTP" name="otp">
              <Input
                placeholder="Type here"
                disabled={!isMobileNumberVerified || isOTPVerified}
                // suffix={
                //   isMobileNumberVerified &&
                //   !isOTPVerified && (
                //     <span
                //       style={{
                //         color: "#1677ff",
                //         cursor: "pointer",
                //         fontWeight: 500,
                //       }}
                //       onClick={() => onVerifyMobileClick()}
                //     >
                //       RESEND
                //     </span>
                //   )
                // }
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4}>
            <Form.Item label=" ">
              <Button
                loading={isOTPVerificationLoading}
                type="primary"
                style={{
                  backgroundColor: "rgb(0, 76, 143)",
                  color: "#fff",
                  boxShadow: "0px 2px 8px 0px #00000040",
                  width: "100%",
                }}
                onClick={onVerifyOTPClick}
                disabled={!isMobileNumberVerified || isOTPVerified}
              >
                VERIFY OTP
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default PatientAttendantDetails;
